import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import ListingCollection from '../ListingCollection';
import SkeletonHomeHubRow from 'app/shared/modules/skeleton/SkeletonHomeHubRow';
import { fetchCollectionData } from 'app/shared/flux/actions/HomeHubActions';
import Text from 'app/shared/core/Text';
import { homeHubCollectionsCSS, homeHubCollectionsHeaderCSS } from 'app/shared/modules/HomeHub/styles';
import type { RootReduxState } from 'app/shared/flux/reducers';
import type { Collection } from 'app/shared/flux/reducers/homehub';

type CollectionsProps = {
  collections: Array<Collection>;
  dispatch: Dispatch;
};

function Collections({ collections, dispatch }: CollectionsProps) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // @ts-expect-error fetchCollectionData is a thunk action that doesn't match AnyAction type
    dispatch(fetchCollectionData())
      .then(() => setIsLoaded(true))
      .catch((err: Error) => {
        dispatch(
          // @ts-expect-error errorHandler is a thunk action that doesn't match AnyAction type
          ErrorActions.errorHandler({
            error: err,
            errorLocation: 'HomeHub/Collections#fetchCollectionData',
            errorClass: 'dataError.HomeHub/Collections#fetchCollectionData',
          }),
        );
      });
  }, [dispatch]);

  if (isLoaded && collections?.length === 0) {
    return null;
  } else {
    return (
      <section className={homeHubCollectionsCSS}>
        <div className={homeHubCollectionsHeaderCSS}>
          <Text htmlTag="h2" size="xl">
            <strong>For you</strong>
          </Text>
          <hr />
        </div>
        {isLoaded || collections.length > 0 ? (
          <>
            {collections.map((collection, i) => {
              return <ListingCollection {...collection} key={`${collection.title}-${i}`} collectionIndex={i} />;
            })}
          </>
        ) : (
          <>
            <SkeletonHomeHubRow />
            <SkeletonHomeHubRow />
          </>
        )}
      </section>
    );
  }
}

const mapStateToProps = (state: RootReduxState) => {
  return {
    collections: state.homehub.collections,
  };
};

export default connect(mapStateToProps)(Collections);
